export default {
    secondVisit: 'ویزیت بعدی',
    date: 'تاریخ',
    mama: 'ماما',
    complaintAndAssessment: 'توضیحات',
    nextAppointment: 'تاریخ مراجعه بعدی',
}